import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UploadBannerSlice = createSlice({
    name: "uploadBanner",
    initialState,
    reducers: {
        uploadBannerRequest(state) {
            state.loading = true;
        },
        uploadBannerRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        uploadBannerRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        uploadBannerStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    uploadBannerRequest,
    uploadBannerRequestSuccess,
    uploadBannerRequestError,
    uploadBannerStateReset,
} = UploadBannerSlice.actions;

export default UploadBannerSlice.reducer;
